import type { CombinedError } from '@urql/core';
import type { GraphQLError } from 'graphql';

import { findGraphqlErrorWithCode } from '~/utils/graphql';

/**
 * The code the server refuses a `setPassword` with when the single-use verification behind the
 * change token was already spent or had expired.
 *
 * It is the one rejection that costs the caller its token. Everything else the resolver can
 * refuse — a password below the length rule, a rate limit — is refused before the token is
 * consumed, so the verification is still live and the same token can carry a corrected retry.
 * Treating those as spent throws away a verification the student would have to earn again.
 */
const PASSWORD_CHANGE_NOT_VERIFIED = 'PASSWORD_CHANGE_NOT_VERIFIED';

export const findPasswordChangeUnverifiedError = (error: CombinedError): GraphQLError | undefined =>
  findGraphqlErrorWithCode(error, PASSWORD_CHANGE_NOT_VERIFIED);

/** The refusal carries localised copy of its own; a caller's own wording is only the fallback. */
export const passwordChangeUnverifiedMessage = (graphQLError: GraphQLError, fallback: string): string =>
  (graphQLError.extensions?.clientMessage as string | undefined) ?? fallback;
